/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Confirm_All_MatchedInputs */

const cs_pm_confirm_all_matched = /** @type {(inputs: Pm_Confirm_All_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdit všechny spárované`)
};

const en_pm_confirm_all_matched = /** @type {(inputs: Pm_Confirm_All_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm all matched`)
};

/**
* | output |
* | --- |
* | "Confirm all matched" |
*
* @param {Pm_Confirm_All_MatchedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_confirm_all_matched = /** @type {((inputs?: Pm_Confirm_All_MatchedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Confirm_All_MatchedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_confirm_all_matched(inputs)
	return cs_pm_confirm_all_matched(inputs)
});